import React from "react";
import NavAndHero from "../components/NavAndHero";
import CallToAction from "../components/CTA";
import Footer from "../components/Footer";
import { ReactComponent as ITImage } from "../images/undraw_progressive-app_9517.svg"; // swap in your preferred SVG

const ITServicePage = () => {
  return (
    <div data-theme="light">
      <NavAndHero />

      {/* Intro Section */}
      <section className="bg-blue-500 rounded-b-3xl py-20 px-4 text-center">
        <div className="max-w-3xl mx-auto space-y-6">
          <h1 className="text-4xl md:text-5xl font-bold text-white">
            IT Services
          </h1>
          <p className="text-lg text-gray-100">
            Reliable IT solutions that keep your business connected, secure, and scalable. From tech support to cloud services, we handle the tech so you can focus on growth.
          </p>
        </div>
      </section>

      {/* Details Section */}
      <section className="py-20 px-4 bg-base-100">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 max-w-7xl mx-auto items-center">
          {/* Text */}
          <div className="space-y-4">
            <h2 className="text-4xl font-bold text-blue-500">What We Deliver</h2>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li>24/7 Technical Support</li>
              <li>Network Infrastructure Setup</li>
              <li>Device Configuration & Onboarding</li>
              <li>Software Installation & Licensing</li>
            </ul>
          </div>

          {/* Image */}
          <div className="flex justify-center">
            <ITImage className="w-full max-w-md h-auto" />
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="bg-blue-100 py-20 px-4">
        <div className="max-w-6xl mx-auto text-center space-y-10">
          <h2 className="text-3xl font-bold text-blue-500">Why Partner With Digiscape?</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10 text-left">
            <div>
              <h3 className="text-xl font-semibold">🛠 Expert Support</h3>
              <p className="text-gray-700">
                From troubleshooting to proactive monitoring — we’ve got your back.
              </p>
            </div>
            <div>
              <h3 className="text-xl font-semibold">🔐 Security First</h3>
              <p className="text-gray-700">
                We ensure your systems and data are protected from threats, always.
              </p>
            </div>
            <div>
              <h3 className="text-xl font-semibold">🚀 Scalable Systems</h3>
              <p className="text-gray-700">
                Future-proof IT infrastructure that grows with your business.
              </p>
            </div>
          </div>
        </div>
      </section>

      <div id="cta">
        <CallToAction />
      </div>
      <Footer />
    </div>
  );
};

export default ITServicePage;
